// Central registry for data-testid strings used across the app.
export const TID = {
  // global
  navHome: "nav-home",
  navStores: "nav-stores",
  navCart: "nav-cart",
  navOrders: "nav-orders",
  navProfile: "nav-profile",
  navLogout: "nav-logout",
  cartBadge: "cart-badge",
  // landing / auth
  landingLoginBtn: "landing-login-btn",
  landingCtaBtn: "landing-cta-btn",
  authGoogleBtn: "auth-google-btn",
  ageVerifyModal: "age-verify-modal",
  ageVerifyInput: "age-verify-input",
  ageVerifySubmit: "age-verify-submit",
  // role
  rolePickerCustomer: "role-picker-customer",
  rolePickerDriver: "role-picker-driver",
  rolePickerStore: "role-picker-store",
  // customer
  homeHero: "customer-home",
  searchInput: "search-input",
  storeCard: "store-card",
  productCard: "product-card",
  addToCartBtn: "add-to-cart-btn",
  incQty: "increment-qty",
  decQty: "decrement-qty",
  cartCheckoutBtn: "cart-checkout-btn",
  addressInput: "address-input",
  checkoutPayBtn: "checkout-pay-btn",
  orderTracking: "order-tracking",
  orderTrackingMap: "order-tracking-map",
  // driver
  driverAvailToggle: "driver-availability-toggle",
  driverAcceptBtn: "driver-accept-btn",
  driverPickupBtn: "driver-pickup-btn",
  driverDeliveringBtn: "driver-delivering-btn",
  driverDeliveredBtn: "driver-delivered-btn",
  // store admin
  storeAdminDashboard: "store-admin-dashboard",
  storeOrderCard: "store-order-card",
  storePrepBtn: "store-prep-btn",
  storeReadyBtn: "store-ready-btn",
  storeAddProduct: "store-add-product",
};
